import { Style } from '../..';

const EditMetadataValueStyles: Style = {
    checkedTrue: {
        color: 'primary.main',
    },
    checkedFalse: {
        color: 'secondary.main',
    },
    field: {
        width: '100%',
        height: '40px',
    },
};

export default EditMetadataValueStyles;
